
import { apiFetch } from '@ami/react/core';

const _baseEndPoint = 'quotes';

export default {
  updateLeadTimeOverrides: (quoteId, quoteProductId, input) => {
    const leadTimeOverrides = input.leadTimeOverrides.map(x => new LeadTimeOverrideInput(x));
    const reason = input.reason;
    const removedLeadTimeOverrideKeys = input.removedLeadTimeOverrideKeys;

    return apiFetch(`${_baseEndPoint}/${quoteId}/product-lead-times/${quoteProductId}`, 'PUT', { leadTimeOverrides, removedLeadTimeOverrideKeys, reason });
  }
};

export class LeadTimeOverrideInput {
  constructor(item) {
    if (item) {
      this.key = item.key;
      this.value = item.value;
      this.availableOn = item.availableOn;
      this.unit = item.unit;
    }
  }
}
